import qs from 'qs'
import { VideoDraftsFilters, VideoDraftsResponse, PostVideoDraft, PostVideoDraftsResponse } from '@/services/video-drafts/types'
import api from '@/services/api'

const getVideoDrafts = async (filters: VideoDraftsFilters): Promise<VideoDraftsResponse> => {
  const response = await api.get<VideoDraftsResponse>('/videos/drafts', {
    params: filters,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    }
  })
  return response.data
}

const getVideoDraftsCount = async (): Promise<number> => {
  const response = await getVideoDrafts({ total_only: true })
  return response.total
}

const saveVideoDrafts = async (drafts: PostVideoDraft[]): Promise<PostVideoDraftsResponse> => {
  const response = await api.post<PostVideoDraftsResponse>('/videos/drafts', { drafts })
return response.data
}

const deleteVideoDrafts = async (draft_ids: number[]) => {
  const response = await api.delete('/videos/drafts', {
    data: {
      draft_ids
    }
  })
  return response.data
}

export default {
  getVideoDrafts,
  getVideoDraftsCount,
  saveVideoDrafts,
  deleteVideoDrafts
}
